import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'video-player',
  templateUrl: './video-player.component.html',
})
export class VideoPlayerComponent implements AfterViewInit {
  @Input() src: string;
  @Output() onVideoEnd = new EventEmitter<any>();

  @ViewChild('video', { static: true }) public video: ElementRef;
  @ViewChild('playPause', { static: true }) public playPause: ElementRef;
  @ViewChild('skipBack', { static: true }) public skipBack: ElementRef;

  public isPaused: boolean = true;

  public currentTime = '00:00';
  public totalTime = '00:00';
  private hasHours: boolean;

  constructor() { }

  ngAfterViewInit() {
    const video: HTMLVideoElement = this.video.nativeElement;
    const playPause: HTMLElement = this.playPause.nativeElement;
    const skipBack: HTMLElement = this.skipBack.nativeElement;

    playPause.addEventListener('click', (e) => {
      if (video.paused || video.ended) {
        video.play();
        this.isPaused = false;
      } else {
        video.pause();
        this.isPaused = true;
      }
    });

    skipBack.addEventListener('click', (e) => {
      video.currentTime = video.currentTime - 10;
    });

    video.addEventListener('timeupdate', (event) => {
      this.totalTime = this.secondsToDisplayTime(video.duration);
      this.currentTime = this.secondsToDisplayTime(event.target['currentTime']);
    });

    video.addEventListener('ended', (event) => {
      this.onVideoEnd.emit(true);
    });
  }

  private secondsToDisplayTime(time: number) {
    let hours = Math.floor(time / 3600);
    let minutes = Math.floor((time % 3600) / 60);
    let seconds = Math.floor(time % 60);

    // dictated by this.hasHours first, even if only seconds in input time param (lets current time match the format of the full duration)
    this.hasHours = this.hasHours || hours > 0;

    let display = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    if (this.hasHours) {
      display = hours + ':' + display;
      this.hasHours = true;
    }

    return display;
  }
}
